import {
  initializeAutocomplete
} from "../../visuell-identitet/AutocompleteUtil.js";


export default function initializeSearchPageAutocomplete() {
  const categoryInput = document.querySelector('input[name="data-category"]') as HTMLInputElement;
  if (document.querySelectorAll(".search-header__button").length > 0 && categoryInput) {
    const useAutocomplete = document.body.getAttribute("data-useautocomplete") === "true";
    if (!useAutocomplete) return;

    const searchField = document.getElementById("search") as HTMLInputElement;
    const resultContainer = document.querySelector(".search-header__autocomplete") as HTMLElement;
    const searchCategory = categoryInput.value;
    const topDiv = document.createElement("div");
    const bottomDiv = document.createElement("div");

    topDiv.id = "intra-result-topdiv";
    bottomDiv.id = "intra-result-bottomdiv";

    topDiv.className = "autocomplete-result__top-section";
    bottomDiv.className = "autocomplete-result__bottom-section grid" + (searchCategory !== 'alla' ? '  autocomplete-result__bottom-section--single' : '');
    resultContainer?.append(topDiv, bottomDiv);

    initializeAutocomplete(searchField, resultContainer, searchCategory, topDiv, bottomDiv, false);
  }
}

// Initialize autocomplete when the page is loaded
if(document.readyState !== 'loading') {
  initializeSearchPageAutocomplete();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    initializeSearchPageAutocomplete();
  });
}